import React from "react";
import { Button } from "react-bootstrap";
import "./GridButton.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faEdit,
  faEye,
  faGem,
  faLeftLong,
  faList,
  faPaperclip,
  faPencilSquare,
  faPlus,
  faPrint,
  faTimesCircle,
  faTrash,
  faTrashCan,
  faUser,
} from "@fortawesome/free-solid-svg-icons";

export const EditButton = ({ onClickHandler }) => {
  return (
    <Button
      className="Primary-OutLint-Button"
      style={{ padding: "0px", width: "100%" }}
      onClick={onClickHandler}
    >
      <FontAwesomeIcon icon={faEdit} className="iconsFonts" aria-hidden="true" />
    </Button>
  );
};

export const DeleteButton = ({ onClickHandler }) => {
  return (
    <Button
      style={{ padding: "0px", width: "100%" }}
      className="Danger-OutLint-Button"
      onClick={onClickHandler}
    >
      <FontAwesomeIcon icon={faTrashCan} aria-hidden="true" className="iconsFonts" />
    </Button>
  );
};

export const PrintButton = ({ onClickHandler }) => {
  return (
    <Button
      className="Danger-OutLint-Button"
      style={{ padding: "0px", width: "100%" }}
      onClick={onClickHandler}
    >
      <FontAwesomeIcon icon={faPrint} className="iconsFonts" aria-hidden="true" />
    </Button>
  );
};

export const AttachedFileButton = ({ onClickHandler }) => {
  return (
    <Button
      className="Black-OutLint-Button"
      style={{ padding: "0px", width: "100%" }}
      onClick={onClickHandler}
    >
      <FontAwesomeIcon icon={faPaperclip} className="iconsFonts" aria-hidden="true" />
    </Button>
  );
};

export const ViewImageButton = ({ onClickHandler }) => {
  return (
    <Button
      className="more-OutLint-Button"
      style={{ padding: "0px", width: "100%" }}
      onClick={onClickHandler}
    >
      <FontAwesomeIcon icon={faEye} className="iconsFonts" aria-hidden="true" />
    </Button>
  );
};


export const ShowSubuserButton = ({ onClickHandler }) => {
  return (
    <Button
      className="Primary-OutLint-Button"
      style={{ padding: "0px", width: "100%" }}
      onClick={onClickHandler}
    >
      <FontAwesomeIcon icon={faUser} className="iconsFonts" aria-hidden="true" />
    </Button>
  );
};

export const ShowGemButton = ({ onClickHandler }) => {
  return (
    <Button
      className="Primary-OutLint-Button"
      style={{ padding: "0px", width: "100%" }}
      onClick={onClickHandler}
    >
      <FontAwesomeIcon icon={faGem} className="iconsFonts" aria-hidden="true" />
    </Button>
  );
};


// export const EditATag = ({ onClickHandler }) => {
//   return (
//     <a
//       className=" btn Primary-OutLint-Button"
//       style={{ padding: "0px", width: "100%" }}
//       href="#"
//       onClick={onClickHandler}
//     >
//       <FontAwesomeIcon icon={faPencilSquare} aria-hidden="true" className="iconsFonts" />
//     </a>
//   );
// };

// export const DeleteATag = ({ onClickHandler, MoreClassName }) => {
//   return (
//     <a
//       className={` btn Danger-OutLint-Button ${MoreClassName}`}
//       style={{ padding: "0px", width: "100%" }}
//       onClick={onClickHandler}
//       href="#"
//     >
//       <FontAwesomeIcon icon={faTrash} aria-hidden="true" className="iconsFonts" />
//     </a>
//   );
// };

// export const ActiveDeActiveButton = ({ onClickHandler, value }) => {
//   return (
//     <Button
//       className={` ${value === true ? "Success-OutLint-Button" : "Danger-OutLint-Button"
//         }`}
//       style={{ padding: "0px", width: "100%" }}
//       onClick={onClickHandler}
//     >
//       {value === true ? (
//         <FontAwesomeIcon icon={faCheckCircle} className="iconsFonts" />
//       ) : (
//         <FontAwesomeIcon icon={faTimesCircle} className="iconsFonts" />
//       )}
//     </Button>
//   );
// };

// export const OtherButtonForGrid = ({ onClickHandler, variant, Icon }) => {
//   return (
//     <Button className="" style={{ padding: "0px", width: "100%" }} variant={variant} onClick={onClickHandler}>
//       <FontAwesomeIcon icon={Icon} className="iconsFonts" aria-hidden="true" />
//     </Button>
//   );
// };

// export const AddNewPlusButton = ({
//   onClick,
//   className = "",
//   style = {},
//   variant = "outline-primary",
// }) => {
//   return (
//     <button
//       className={`btn Responsive-Plus-Btn btn-${variant} ${className}`}
//       onClick={onClick}
//       style={style}
//     >
//       <FontAwesomeIcon icon={faPlus} className="box-shadow-none" />
//     </button>
//   );
// };

// export const ShowListButton = ({ onClick }) => {
//   return (
//     <Button variant="outline-primary" onClick={onClick}>
//       <FontAwesomeIcon icon={faList} className="box-shadow-none" />
//     </Button>
//   );
// };

// export const GoToBackButton = ({ onClick }) => {
//   return (
//     <Button variant="outline-secondary" onClick={onClick}>
//       <FontAwesomeIcon icon={faLeftLong} className="box-shadow-none" />
//     </Button>
//   );
// };
